export const NEWS = [
  {
    id: 1,
    date: '2026-03-10',
    tag: 'Announcement',
    title: 'Server Launch Confirmed - April 5, 2026',
    summary: 'We are proud to announce the official launch date. Open Beta begins March 28. Register now to secure your character name.',
  },
  {
    id: 2,
    date: '2026-03-07',
    tag: 'Balance',
    title: 'Class Balance Update - Archers & Mages',
    summary: 'Adjusted archer range skills and mage MP regeneration to bring competitive viability in line with our x1 rate philosophy.',
  },
  {
    id: 3,
    date: '2026-03-01',
    tag: 'Event',
    title: 'Grand Opening Events Announced',
    summary: 'Special launch week events including double XP weekends, starting gift packages and a clan recruitment fair in Giran.',
  },
  {
    id: 4,
    date: '2026-02-22',
    tag: 'Update',
    title: 'Server Infrastructure Upgrade Complete',
    summary: 'Migrated to dedicated hardware with improved DDoS protection. Expected 99.9% uptime and sub-50ms latency for EU players.',
  },
];
